import { discoveryQueryKeys as e } from "./useDiscoveryQueryKeys.mjs";
import { useInfiniteListQuery as t } from "@maat/store-hooks";
import { discoverApi as n } from "@maat/api-main";
//#region src/discovery/useDiscoverListingsQuery.ts
var r = (r, i = {}) => t({
	queryKey: e.listings(r),
	fetchPage: (e) => n.listListings({
		...r,
		page: e
	}),
	key: "items",
	enabled: i.enabled
});
//#endregion
export { r as useDiscoverListingsQuery };
